import React from 'react';

import { appMethod as app } from '@utils/app';
import { convertLineStyleData } from '@utils/tools';

import { GoodsShoppingCart } from 'src/common/goods-shopping-cart/GoodsShoppingCart';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GoodsFootPrint.less';

export default class GoodsFootPrint extends OfficialPage {
  state = {
    goodslist: [],
    search: '',
    selectAll: false,
    storeStyle: {}
  }
  page = 1
  isMore = 1

  goodsShoppingCartRef = React.createRef();

  constructor(props) {
    super(props);
    document.title = '足迹';
  }

  componentWillMount() {
    this.dataInitial()
  }

  componentDidMount() { }

  dataInitial = () => {
    this.getGoodsViewRecordList()
    this.getAppECStoreConfig()
  }
  getGoodsViewRecordList = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/goodsViewRecordList',
      data: {
        page: _this.page,
        page_size: 10,
        search: _this.data.search
      },
      success: function (res) {
        _this.setData({
          goodslist: _this.data.goodslist.concat(res.data)
        })
        _this.isMore = res.is_more
      }
    })
  }
  footPrintOperat = () => { }
  footPrintOperat = () => {
    this.setData({
      showCheckedBox: true
    })
  }
  footPrintComplete = () => {
    this.setData({
      showCheckedBox: false
    })
  }
  addShoppingCart = event => {
    event.stopPropagation();
    this.goodsShoppingCartRef.current.showDialog({
      goodsId: event.currentTarget.dataset.id
    })
  }
  goGoodsDetail = event => {
    app.turnToPage(
      '/pages/goodsDetail/goodsDetail?detail=' + event.currentTarget.dataset.id
    )
  }
  selectGoods = event => {
    let index = event.currentTarget.dataset.index
    let goodslist = this.data.goodslist
    let selectAll = true
    goodslist[index].selected = !goodslist[index].selected
    goodslist.map(item => {
      if (!item.selected) {
        selectAll = false
      }
    })
    this.setData({
      goodslist: goodslist,
      selectAll: selectAll
    })
  }
  clickSelectAll = () => {
    let selectAll = this.data.selectAll
    let goodslist = this.data.goodslist
    goodslist.map(item => {
      item.selected = !selectAll
    })
    this.setData({
      goodslist: goodslist,
      selectAll: !selectAll
    })
  }
  onReachBottom = () => {
    if (!this.isMore) {
      return
    }
    this.page++
    this.getGoodsViewRecordList()
  }
  deleteGoods = () => {
    let _this = this
    let deleteIdArr = []
    let goodslist = this.data.goodslist
    for (let i = 0; i < goodslist.length; i++) {
      if (goodslist[i].selected) {
        deleteIdArr.push(goodslist[i].id)
        goodslist.splice(i, 1)
        i--
      }
    }
    if (deleteIdArr.length <= 0){
      app.showToast({title: '未选择商品', icon: 'none'});
      return;
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/deleteGoodsViewRecord',
      method: 'post',
      data: {
        goods_id_arr: deleteIdArr
      },
      success: function (res) {
        _this.setData({
          goodslist: goodslist,
          showCheckedBox: false
        })
      }
    })
  }
  searchGoods = event => {
    if (event.keyCode !== 13) {
      return;
    }
    this.page = 1
    this.setData({
      search: event.target.value,
      goodslist: []
    })
    this.getGoodsViewRecordList()
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    })
  }

  render() {
    const {
      showGetUserInfo,
      showCheckedBox,
      goodslist,
      storeStyle,
      selectAll,
      search
    } = this.state

    return (
      <React.Fragment>
        <div className="official-page goods-foot-print">
           <TopNav title="参团足迹" />
          {goodslist.length || search ? (
            <React.Fragment>
              <div className={showCheckedBox ? 'foot-print-container' : ''}>
                <div className="foot-print-header">
                  <div className="foot-print-search">
                    <span className="ico-moon icon-search"></span>
                    <input
                      type="text"
                      onKeyDown={this.searchGoods}
                      placeholder="请输入搜索内容"
                    />
                  </div>
                  {!showCheckedBox ? (
                    <span
                      className="foot-print-operat"
                      onClick={this.footPrintOperat}
                    >
                      管理
                    </span>
                  ) : (
                      <span
                        className="foot-print-operat"
                        onClick={this.footPrintComplete}
                      >
                        完成
                    </span>
                    )}
                </div>
                <div className="foot-print-content">
                  <div className="goods-content">
                    {goodslist.map((item, index) => {
                      return (
                        <div
                          key={item.id}
                          onClick={
                            item.status != 1 && !showCheckedBox
                              ? this.goGoodsDetail
                              : null
                          }
                          data-id={item.id}
                        >
                          <img className="goods-cover" src={item.cover} />
                          <div className="goods-detail">
                            <div className="goods-title">{item.title}</div>
                            <div
                              className="goods-price"
                              style={convertLineStyleData('color:' + storeStyle.theme)}
                            >
                              {'¥' + item.price}
                            </div>
                            <div className="goods-bottom">
                              {item.sales + '人付款'}
                              {item.status == 1 ? (
                                <span className="foot-invalid">失效</span>
                              ) : (
                                  <span
                                    onClick={
                                      showCheckedBox ? null : this.addShoppingCart
                                    }
                                    data-id={item.id}
                                    className="ico-moon icon-addshoppingcart3 add-shopping-cart"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  ></span>
                                )}
                            </div>
                          </div>
                          {showCheckedBox && (
                            <label
                              data-index={index}
                              className={
                                'foot-check-box ' +
                                (item.selected
                                  ? 'checked ico-moon icon-success-tip'
                                  : '')
                              }
                              style={convertLineStyleData('color:' + storeStyle.theme)}
                              onClick={this.selectGoods}
                            ></label>
                          )}
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
              {showCheckedBox && (
                <div className="foot-bottom">
                  <div className="select-all">
                    <label
                      className={
                        'foot-check-box ' +
                        (selectAll ? 'checked ico-moon icon-success-tip' : '')
                      }
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                      onClick={this.clickSelectAll}
                    ></label>
                    <span>全选</span>
                  </div>
                  <div
                    className="pull-right delete-goods"
                    style={convertLineStyleData('background:' + storeStyle.theme)}
                    onClick={this.deleteGoods}
                  >
                    一键删除
                  </div>
                </div>
              )}
            </React.Fragment>
          ) : (
              <React.Fragment>
                <div className="foot-null-box">
                  <img src="http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-goods/foot-print-null.png" />
                  <div>暂时没有浏览记录</div>
                </div>
              </React.Fragment>
            )}
        </div>
        <GoodsShoppingCart ref={this.goodsShoppingCartRef} />
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/goods-foot-print/GoodsFootPrint.jsx